import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { Menu, X, LogOut, User, Calendar } from "lucide-react";
import { Button } from "./ui/button";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userType, setUserType] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const type = localStorage.getItem("user_type");
    setIsLoggedIn(!!token);
    setUserType(type);
  }, [location]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  };

  const isActive = (path) => location.pathname === path;

  // Hide header for admin routes
  if (location.pathname.startsWith("/admin")) {
    return null;
  }

  const navLinks = [
    { name: "Accueil", path: "/" },
//    { name: "Méthodologie", path: "/methodologie" },
    !isLoggedIn && { name: "Cédants", path: "/cedant" },
    !isLoggedIn && { name: "Repreneurs", path: "/repreneur" },
    userType === "cedant" 
      ? { name: "Ma Fiche", path: "/cedant/resultat" }
      : { name: "Opportunités", path: "/opportunites" },
  ].filter(Boolean);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src="/logo.png" alt="Sequenti Logo" className="h-10 w-auto" />
          </Link>
        </div>

        <nav className={`nav-menu ${isOpen ? "open" : ""}`}>
          <ul className="nav-list">
            {navLinks.map((link) => (
              <li key={link.path} className="nav-item">
                <Link
                  to={link.path}
                  className={`nav-link ${isActive(link.path) ? "active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              </li>
            ))}
            <li className="nav-item mobile-only">
              {isLoggedIn ? (
                <>
                  <Link 
                    to="/profile" 
                    className="nav-link flex items-center gap-2 mb-2"
                    onClick={() => setIsOpen(false)}
                  >
                    <User className="w-4 h-4" />
                    Mon Profil
                  </Link>
                  <button 
                    onClick={() => {
                      window.open('https://calendly.com/eric-sequenti/30min', '_blank');
                      setIsOpen(false);
                    }} 
                    className="nav-link text-accent flex items-center gap-2 mb-2"
                  >
                    <Calendar className="w-4 h-4" />
                    Prendre RDV
                  </button>
                  <button onClick={handleLogout} className="nav-link logout-btn">
                    Déconnexion
                  </button>
                </>
              ) : (
                <Link to="/login" className="nav-link" onClick={() => setIsOpen(false)}>
                  Connexion
                </Link>
              )}
            </li>
          </ul>
        </nav>

        <div className="header-actions">
          {isLoggedIn ? (
            <div className="user-menu flex items-center gap-4">
              <Button
                variant="outline"
                className="hidden md:flex border-accent text-accent hover:bg-accent/5 gap-2 rounded-full"
                onClick={() => navigate("/profile")}
              >
                <User className="w-4 h-4" />
                Mon Profil
              </Button>
              <Button
                variant="outline"
                className="hidden md:flex border-accent text-accent hover:bg-accent/5 gap-2 rounded-full"
                onClick={() => window.open('https://calendly.com/eric-sequenti/30min', '_blank')}
              >
                <Calendar className="w-4 h-4" />
                Prendre RDV
              </Button>
              <Button 
                variant="ghost" 
                className="flex items-center gap-2 text-primary hover:text-accent"
                onClick={handleLogout}
              >
                <LogOut className="w-5 h-5" />
                <span className="hidden md:inline">Déconnexion</span>
              </Button>
            </div>
          ) : (
            <Link to="/login">
              <Button className="bg-primary text-white hover:bg-primary/90 px-6 rounded-full">
                Connexion
              </Button>
            </Link>
          )}
        </div>

        <button 
          className="mobile-menu-btn" 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="text-primary" /> : <Menu className="text-primary" />}
        </button>
      </div>
    </header>
  );
};

export default Header;
